import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

export function localized(value: Record<string, string> | undefined | null, locale: string, fallback = ''): string {
  if (!value) return fallback;
  return value[locale] || value['en'] || Object.values(value)[0] || fallback;
}

/** The reader's language, else the default text, and only then whatever other language there is. */
export function localizedOrDefault(value: Record<string, string> | undefined | null, locale: string, defaultText: string | null | undefined): string {
  return value?.[locale] || defaultText || localized(value, locale);
}

export function initials(name: string): string {
  return name
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]!.toUpperCase())
    .join('');
}

export function readableColor(hex: string): string {
  const m = /^#?([0-9a-f]{6})$/i.exec(hex);
  if (!m) return '#111111';
  const n = parseInt(m[1]!, 16);
  const r = (n >> 16) & 255;
  const g = (n >> 8) & 255;
  const b = n & 255;
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.6 ? '#111111' : '#ffffff';
}
